import { createStyles, makeStyles, Theme } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';

import { UserWithTimestampFragment } from '../../../../graphql/gen/types';
import { colorPalette, spacings, TextSizesEnum } from '../../../../theme';
import { formatFullDate } from '../../../../utils/commons';
import { PlexTypography } from '../../../shared/primitives/PlexTypography';
import { PostAuthor } from '../../common/PostAuthor';

type Props = {
  users: UserWithTimestampFragment[];
};

export function UsersList(props: Props): React.ReactElement {
  const { users } = props;
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {users.map((u, i) => (
        <div key={u.user.id} className={classNames(classes.container, i % 2 === 0 && classes.containerOdd)}>
          <PostAuthor
            classes={{
              avatar: classes.avatar,
              name: classes.name,
            }}
            authorName={u.user.name}
            authorAvatar={u.user.picture}
            authorTitle={u.user.jobTitle}
          />
          <PlexTypography text={formatFullDate(new Date(u.atDate))} size={TextSizesEnum.NormalPlus} />
        </div>
      ))}
    </div>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      overflowY: 'auto',
    },
    container: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingLeft: spacings.normal,
      paddingRight: spacings.normal,
      paddingTop: spacings.small,
      paddingBottom: spacings.small,
      alignItems: 'center',
    },
    containerOdd: {
      backgroundColor: '#eee',
    },
    avatarAndName: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    avatar: {
      display: 'flex',
      marginRight: spacings.normal,
      width: 32,
      height: 32,
    },
    name: {
      fontSize: 16,
      color: colorPalette.dark._800,
      fontWeight: 500,
    },
  })
);
